import { AnalyticsEventName } from './constants';
import { NonPromoEvent } from './globalBanner';
import { trackEvent } from './utils';

export const trackViewBlockNameEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.ViewBlockName,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};

export const trackSelectBlockNameEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.SelectBlockName,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};
